import React, { Component } from "react";
import { FormControl } from "react-bootstrap";
import { observer } from "mobx-react";

class Text extends Component {
  handleOnChange(ev) {
    let { model, dataMember } = this.props;
    if (model && dataMember) {
      model[dataMember] = ev.target.value;
    }
  }

  render() {
    let {
      model,
      dataMember,
      placeholder,
      readOnly,
      type,
      required,
      componentClass,
      rows
    } = this.props;

    let value = null;
    if (model && dataMember) {
      value = model[dataMember];
    }

    value = value || "";

    return (
      <FormControl
        value={value || ""}
        type={type}
        readOnly={readOnly}
        onChange={this.handleOnChange.bind(this)}
        placeholder={placeholder || ""}
        required={required}
        componentClass={componentClass}
        rows={rows}
      />
    );
  }
}

export default observer(Text);



// WEBPACK FOOTER //
// ./src/Core/Components/Inputs/Text/index.js